<template>
  <div
    v-loading="loading"
    element-loading-text="数据加载中..."
    element-loading-spinner="el-icon-loading"
    :style="{ height: tableHeight }"
    ref="tablebox"
    :class="['l-x-table', isPage ? 'l-x-table--haspagination' : '']"
  >
    <div class="l-rblock">
      <!-- checkField: multiSelectKey, -->
      <vxe-table
        :data="tableShowData"
        style="width: 100%"
        :height="tableHeight"
        :max-height="maxHeight"
        :size="size"
        :cell-style="cellStyle || { padding: '2px 0' }"
        :header-cell-style="headerCellStyle || { padding: '4px 0' }"
        :stripe="stripe && !isTree"
        :row-config="{
          isHover: isRowHover,
          isCurrent: highlightCurrentRow || singleSelect,
          keyField: rowKey,
        }"
        :column-config="{
          resizable: isColumnResizable,
          isCurrent: isColumnCurrent,
          isHover: isColumnHover,
          minWidth: '80px'
        }"
        :checkbox-config="{
          
          reserve: reserveSelection && isMultiSelect,
          checkStrictly: checkStrictly && isTree,
          checkMethod: selectable
        }"
        :seq-config="{
          seqMethod: indexMethod
        }"
        :tooltip-config="{
          theme: tooltipEffect
        }"
        :sort-config="{
          remote: isPage
        }"
        :border="border"
        :fit="fit"
        :show-header="showHeader"
        :show-footer="showSummary"
        :show-overflow="showOverflow"
        :empty-text="emptyText"
        :footer-method="getSummaries"
        :footer-span-method="footerRowspanMethod"
        :span-method="spanMethod"
        :menu-config="menuConfig"
        :tree-config="treeConfig"
        :scroll-y="myScrollY"
        :scroll-x="{
            enabled: !isExpand,
            gt: scrollXGt
        }"
        :mergeCells="mergeCells"
        :row-class-name="rowClassName"
        :cell-class-name="cellClassName"
        :header-row-class-name="headerRowClassName || 'l-x-table-header-row'"
        :header-cell-class-name="headerCellClassName"
        :default-sort="defaultSort"
        :row-style="rowStyle"
        @scroll="scroll"
        @checkbox-all="handleSelectAll"
        @checkbox-change="selectionChange"
        @cell-mouseenter="cellMouseEnter"
        @cell-mouseleave="cellMouseLeave"
        @cell-click="handleCellClick"
        @cell-dblclick="handleCellDblclick"
        @cell-menu="headerContextmenu"
        @row-click="rowClick"
        @row-contextmenu="rowContextmenu"
        @row-dblclick="rowDblclick"
        @header-cell-click="headerClick"
        @header-cell-menu="headerContextmenu"
        :header-row-style="headerRowStyle"
        @header-contextmenu="headerContextmenu"
        @sort-change="sortChange"
        @filter-change="filterChange"
        @current-change="currentChangeHandler"
        @resizable-change="headerDagend"
        @toggle-row-expand="expandChange"
        ref="learunTable"
        v-if="isShowTable"
      >
      <!-- @sort-change="sortChangeEvent" -->
        <!-- 开启显示树形数据的拖动排序 -->
        <vxe-column align="center" width="45" v-if="isSortable && isTree">
          <template slot="header">
            <i class="el-icon-sort" />
          </template>
          <template slot-scope="scope">
            <span class="learun-table__drag-handler" style="cursor: pointer;" @click="reorder(scope.row)">
              <i class="el-icon-d-caret" />
            </span>
          </template>
        </vxe-column>
        <!-- 拖动排序  -->
        <vxe-column align="center" width="45" v-if="isSortable && !isTree">
          <template slot="header">
            <i class="el-icon-sort" />
          </template>
          <template>
            <span class="learun-table__drag-handler" style="cursor: pointer;">
              <i class="el-icon-rank" />
            </span>
          </template>
        </vxe-column>

        <vxe-column
          v-if="isExpand"
          :fixed="isFixed ? 'left' : ''"
          type="expand"
          width="32"
        >
          <template #content="scope">
            <slot v-bind="scope" name="table_expand"></slot>
          </template>
        </vxe-column>
        <!-- <template v-slot:append>
          <slot name="append"></slot>
        </template> -->
        <vxe-column
          v-if="isShowNum && !isTree"
          :title="ShowNumLabel"
          :fixed="isFixed ? 'left' : ''"
          type="seq"
          :width="seqWidth"
          align="center"
          :resizable="false"
        >
        </vxe-column>
        <vxe-column
          v-if="isMultiSelect && !singleSelect"
          :fixed="isFixed ? 'left' : ''"
          type="checkbox"
          align="center"
          width="60"
          :resizable="false"
          @click.stop.prevent
        >
          <!-- <template v-slot:checkbox="scope">
            <el-checkbox v-model="scope.row.checked" :disabled="scope.row.disabled" size="mini"></el-checkbox>
          </template> -->
        </vxe-column>
        <vxe-column
          v-if="singleSelect"
          :fixed="isFixed ? 'left' : ''"
          title=""
          width="35">
          <template v-slot="scope">
            <el-radio v-model="curtRowKey" :label="scope.row[rowKey]">&nbsp;</el-radio>
          </template>
        </vxe-column>

        <template v-for="(item, index) in tableColumns">
          <!-- :show-overflow="(item.isNotAutoWrap == true ? true : false)  || item.fixed" -->
          <vxe-column
            v-if="!item.children"
            :key="`${item.prop}${index}`"
            :field="item.prop"
            v-bind="item"
            :title="$t(item.label)"
            :fixed="isSortable && !isTree ? '' : (item.fixed === true ? 'left' : '')"
            :sortable="sortable || item.sortable"
            :show-overflow="(item.isNotAutoWrap == true ? true : false)"

            :min-width="item.minWidth"
            :tree-node="isTree && index == 0"
          >
            <template v-slot:header="{ column }">
              <slot v-bind="column" :name="`${column.property}_header`">
                  <span v-if="isRequired(column.property)" style="color: red">*</span><span>{{ column.title }}</span>
                  <el-tooltip v-if="item.tip" class="item" effect="dark" :content="$t(item.tip)" placement="bottom">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  <i v-if="isEditable(column.property)" class="el-icon-edit" style="margin-left: 4px;"></i>

              </slot>
              <!-- <span v-if="isRequired(column.property)" style="color: red"
                >*</span
              ><span>{{ column.title }}</span> -->
            </template>
            <template v-slot="slotProps">
              <slot v-bind="slotProps" :name="item.prop">{{
                columnText(slotProps.$index, slotProps.row, item, slotProps)
              }}</slot>
            </template>
          </vxe-column>
          <x-dynamic-column
            v-else
            :showOverflowTooltip="(item.isNotAutoWrap == true ? true : false || item.fixed)"
            :columnOption="item"
            :columnText="columnText"
            :isRequired="isRequired"
            :isEditable="isEditable"
            :title="$t(item.label)"
            :key="index"
            :fixed="isSortable && !isTree ? '' : (item.fixed === true ? 'left' : item.fixed)"
            :sortable="sortable"
            :allProps="item.props"
            :colIndex="index"
          >
            <template
              v-for="myProp in item.props || []"
              v-slot:[myProp]="scope"
            >
              <slot v-bind="scope" :name="myProp"></slot>
            </template>
            <template
              v-for="myProp in item.props || []"
              v-slot:[`${myProp}_header`]="{ column }"
            >
              <slot v-bind="column" :name="`${myProp}_header`"></slot>
            </template>
          </x-dynamic-column>
        </template>
        <slot></slot>
      </vxe-table>
      
    </div>

    <div v-if="isPage" class="l-table--pagination">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes || [20, 50, 100, 200]"
        :page-size.sync="currentPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
      >
      </el-pagination>
    </div>
    <l-drawer
      :title="$t('表格列设置')"
      :visible.sync="columnsVisible"
      :showOk="false"
      :showClose="false"
      :wrapperClosable="true"
      :modal="false"
      size="320px"
      @opened="columnsSettingOpened"
    >
      <el-tree
        ref="columnsTree"
        node-key="_id"
        show-checkbox
        :data="treeColumns"
        @check="handleColumnsCheck"
        draggable
        :allow-drop="allowDrop"
        @node-drop="handleDrop"
      >
      </el-tree>
    </l-drawer>
    <l-columns-config ref="columnsConfig" tableType="new" :scrollYGt="scrollYGt" :scrollXGt="scrollXGt" @ok="handleColumnsConfigOk"/>
  </div>
</template>
<script>
import tableEvent from "@util/newTableEvent";
import tableUtil from "@util/tableUtil";
import xDynamicColumn from "./x-dynamic-column";
import {cloneDeep} from 'lodash';
// 事件： sortable-change(表格行排序变更触发)
export default {
  name: "l-new-table",
  mixins: [tableEvent(), tableUtil()],
  components: {
    xDynamicColumn,
  },
  props: {
    tid: {
      type: String,
      default: "",
    },
    tableId: {
      type: String,
      default: "",
    },
    disabeledList: {
      default: ''
    },
    columns: {
      type: Array,
      default: function () {
        return [];
      },
    },
    columnsType: {
      type: String,
      default: "tree",
    },
    dataSource: {
      type: Array,
      default: function () {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: "100%",
    },
    maxHeight: {
      type: [String, Number],
    },
    minHeight: {
      type: [String, Number],
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true,
    },
    rowClassName: [String, Function],
    cellClassName: [String, Function],
    headerRowClassName: [String, Function],
    headerCellClassName: [String, Function],
    rowStyle: [Function, Object],
    cellStyle: [Function, Object],
    headerCellStyle: [Function, Object],
    stripe: {
      type: Boolean,
      default: false,
    },
    border:{
      type: [String, Boolean],
      default: false
    },
    tooltipEffect: String,
    showSummary: {
      type: Boolean,
      default: false,
    },
    showOverflow: [String, Boolean],
    sumText: {
      type: String,
      default: "合计",
    },
    summaryMethod: Function,
    isShowNum: {
      type: Boolean,
      default: true,
    },
    ShowNumLabel: {
      type: String,
      default: "序号",
    },
    ShowNumWidth:{
      type: [String, Number],
      default: "55",
    },
    isMultiSelect: Boolean,
    multiSelectKey: String,
    rowKey: String,
    reserveSelection: {
      type: Boolean,
      default: true,
    },
    isExpand: {
      type: Boolean,
      default: false,
    },
    isTree: {
      type: Boolean,
      default: false,
    },
    idKey: {
      type: String,
    },
    pidKey: {
      type: String,
    },
    indent: {
      type: Number,
      default: 16,
    },
    lazy: Boolean,
    load: Function,
    defaultExpandAll: Boolean,
    checkStrictly: Boolean,
    expandRowKeys: {
      type: Array,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    defaultSort: Object, //{field, order[asc|desc|null]}
    isSortable: {
      type: Boolean,
      default: false,
    },
    spanMethod: Function,
    isPage: {
      type: Boolean,
      default: false,
    },
    pageSizes: Array,
    pageTotal: {
      type: Number,
      default: 0,
    },
    tablePage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 50,
    },
    pageLayout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    isChild: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    lrTableName: {
      type: String,
      default: function () {
        return window.location.href;
      },
    },
    hasChildren: {
      type: String,
      default: "hasChildren",
    },
    scrollYGt: {
      type: Number,
      default: 30,
    },
    scrollXGt: {
      type: Number,
      default: 20
    },
    // 似乎是用来给原有框架中指定table的border属性的参数，但现已改为直接使用border属性
    borderType: {
      type: String,
    },
    isRowHover: {
      type: Boolean,
      default: true,
    },
    isColumnCurrent: Boolean,
    isColumnHover: {
      type: Boolean,
      default: false,
    },
    isColumnResizable: {
      type: Boolean,
      default: true,
    },
    isNotMinWidth: Boolean,
    mergeCells: Array,
    isBigData: Boolean,
    size: {
      default: 'mini'
    },
    singleSelect: {
      default: false
    },
    currentRowKey: {
      default: ''
    },
    fixedLeft: {
      default: false
    }
  },
  data() {
    return {
      columnsVisible: false,
      columnsChecks: null,
      myPageSize: 0,
      sidx: "",
      isShowTable: true,
      isReloading: false,
      dataId: this.$uuid(),
      bigDataLength: -1,
      curtRowKey: '',
      emptyText:'暂无数据',
      myColumns: null,
      startDragIndex: 0
    };
  },
  created() {
    window.tableData = window.tableData || {};
    this.getTableConfig();
  },
  beforeDestroy: function () {
    this.dragSortable && this.dragSortable.destroy() && (this.dragSortable = null);
    delete window.tableData[this.dataId];
  },
  mounted() {
    this.curtRowKey = this.currentRowKey
    this.setSort();
  },
  computed: {
    tableHeight: function () {
      return "notset" == this.height || this.isChild ? void 0 : "100%";
    },
    tableWraperHeight: function () {
      return "notset" == this.height || this.isChild ? void 0 : this.height;
    },
    isFixed: function () {
      return (
        void 0 !=
          this.arrayColumns.find(function (e) {
            return e.fixed || "left" === e.fixed || "right" === e.fixed;
          }) && !this.isSortable
      ) || this.fixedLeft;
    },
    dataSourceLength: function () {
      return -1 != this.bigDataLength
        ? this.bigDataLength
        : this.dataSource.length;
    },
    seqWidth: function () {
      var e = this.indexMethod({rowIndex: this.dataSourceLength}) + "",
        t = 10 * e.length + 20;
      return t < this.ShowNumWidth && (t = this.ShowNumWidth), t;
    },
    // border: function () {
    //   return -1 !=
    //     this.tableColumns.findIndex(function (e) {
    //       return e.children && e.children.length > 0;
    //     })
    //     ? "full"
    //     : this.borderType || false;
    // },
    footerColNum: function () {
      var e = 0;
      return this.isShowNum && e++, this.isMultiSelect && e++, e;
    },
    myScrollY: function () {
      return this.isExpand
        ? {
            enabled: false,
          }
        : this.lazy
        ? {
            enabled: true,
          }
        : {
            gt: this.scrollYGt,
            enabled: true,
          };
    },
    treeConfig: function () {
      return this.isTree
        ? {
            transform: this.lazy,
            rowField: this.idKey || this.rowKey,
            parentField: this.pidKey,
            expandAll: this.defaultExpandAll,
            indent: this.indent,
            lazy: this.lazy,
            loadMethod: this.load,
            hasChildField: this.hasChildren,
            hasChild: this.hasChildren,
            expandRowKeys: this.expandRowKeys,
            reserve: true,
          }
        : null;
    },
    menuConfig: function () {
      return {
        enabled: true,
      };
    },
    // 合并用户配置和原始配置
    mergedColumns() {
      // 如果没有用户配置，直接返回原始 columns（扁平化）
      if (!this.myColumns || !Array.isArray(this.myColumns)) {
        return this.columnsType === 'tree' ? this.$toArray(this.columns) : (this.columns || [])
      }
      
      // 扁平化用户配置的列
      const myColumnsFlat = this.$toArray(this.myColumns)
      
      // 扁平化原始 columns
      const columnsFlat = this.$toArray(this.columns)
      
      // 创建 columns 的 Map，用于快速查找和合并
      const columnsMap = new Map()
      columnsFlat.forEach(col => {
        if (col.prop) {
          columnsMap.set(col.prop, col)
        }
      })
      
      // 记录已处理的 prop，避免重复
      const processedProps = new Set()
      
      // 按用户配置的顺序合并列
      const result = []
      
      myColumnsFlat.forEach(myCol => {
        if (myCol.prop) {
          const sourceCol = columnsMap.get(myCol.prop)
          if (sourceCol) {
            // 合并：优先使用用户配置，但保留 source 中的最新属性
            result.push({
              ...sourceCol,        // 先取原始配置（包含最新属性）
              ...myCol,           // 用用户配置覆盖（保留用户自定义设置）
              _id: myCol._id || sourceCol._id
            })
            processedProps.add(myCol.prop)
          } else {
            // 用户配置中的列在原始 columns 中不存在，可能是用户自定义的列
            // result.push(myCol)
            // processedProps.add(myCol.prop)
          }
        }
      })
      
      // 将原始 columns 中新增的列追加到末尾
      columnsFlat.forEach(col => {
        if (col.prop && !processedProps.has(col.prop)) {
          result.push(col)
        }
      })
      
      return result
    },
    arrayColumns: function () {
      // mergedColumns 已经是扁平化的数组，不需要再次调用 $toArray
      return this.mergedColumns;
    },
    treeColumns: function () {
      // return this.$toTree(this.$deepClone(this.arrayColumns));
      return this.$toTree(this.arrayColumns);
    },
    // chooseItem: function () {
    //   var e,
    //     t = this;
    //   return 0 == this.arrayColumns.length
    //     ? [
    //         {
    //           label: "",
    //           prop: "learun_null",
    //           minWidth: "1",
    //         },
    //       ]
    //     : ((e =
    //         null != this.columnsChecks
    //           ? this.arrayColumns.filter(function (e) {
    //               return -1 != t.columnsChecks.indexOf(e._id);
    //             })
    //           : this.arrayColumns.filter(function (e) {
    //               return -1 != t.defaultCheckedKeys.indexOf(e._id);
    //             })),
    //       0 == e.length
    //         ? [
    //             {
    //               label: "",
    //               prop: "learun_null",
    //               minWidth: "1",
    //             },
    //           ]
    //         : (this.isNotMinWidth ||
    //             -1 !=
    //               e.findIndex(function (e) {
    //                 return e.minWidth;
    //               }) ||
    //             ((e[0].minWidth = e[0].width || "1"), delete e[0].width),
    //           e));
    // },
    tableColumns: function () {
      // return this.$toTree(this.chooseItem);
      const sourceColumns = this.mergedColumns
      
      if (sourceColumns.length == 0) {
        if (this.cancelColumn) {
          return [{ label: "", prop: "learun_null", minWidth: "1" }];
        } else {
          return []
        }
      }
      
      let res;
      if (this.columnsChecks && this.columnsChecks.length) {
        const mergedArrayColumns = this.$toArray(sourceColumns)
        
        res = mergedArrayColumns.filter(
          (t) => this.columnsChecks.indexOf(t._id) != -1
        );
        res = res.sort((a, b) => {
          return this.columnsChecks.indexOf(a.prop) - this.columnsChecks.indexOf(b.prop)
        })
      } else {
        const mergedArrayColumns = this.$toArray(sourceColumns)
        res = mergedArrayColumns.filter(
          (t) => this.defaultCheckedKeys.indexOf(t._id) != -1
        );
      }
      
      if (res.length == 0) {
        return [{ label: "", prop: "learun_null", minWidth: "1" }];
      }
      
      return this.$toTree(res);
    },
    defaultCheckedKeys: function () {
      var e,
        t = window.$getStore({
          name: "table_setting_cols",
        });
      if (
        t &&
        (this.loginInfo
          ? t[this.loginInfo.f_UserId] &&
            t[this.loginInfo.f_UserId][this.lrTableName] &&
            (e = t[this.loginInfo.f_UserId][this.lrTableName])
          : (e = t[this.lrTableName]),
        e)
      )
        return e;
      return this.arrayColumns
        .filter(function (e) {
          return 1 != e.isNotShow;
        })
        .map(function (e) {
          return e._id;
        });
    },
    currentPageSize: {
      get: function () {
        return 0 != this.myPageSize ? this.myPageSize : this.pageSize;
      },
      set: function (e) {
        (this.myPageSize = e), this.$emit("update:pageSize", e);
      },
    },
    currentPage: {
      get: function () {
        return this.$validatenull(this.tablePage) ? 1 : this.tablePage;
      },
      set: function (e) {
        this.$emit("update:tablePage", e);
      },
    },
    tableShowData: function () {
      var e = [];
      if (this.isTree && !this.lazy) {
        if (this.isReloading) return [];
        e = this.$toTree(
          this.dataSource,
          this.idKey || this.rowKey,
          this.pidKey,
          this.rowKey,
          this.rowKey
        );
      } else e = this.dataSource;
      return e;
    },
  },
  watch: {
    async tableId() {
      if (this.tableId) {
        this.myColumns = await this.$store.dispatch('data/tableConfig/getConfig', this.tableId)
      }
    },
    currentRowKey(val) {
      this.curtRowKey = val;
    },
    showColumns(val) {
      this.columnsChecks = this.showColumns;
    },
    dataSource() {
      if (this.isChild) {
        let list = this.$el.querySelectorAll(".el-table__row");
        list.forEach((row) => {
          row.classList.add("el-table__row2");
          row.classList.remove("el-table__row");
        });
        list = null
      }
      // this.selectRows();
    },
    columnsChecks(val) {
      if (!this.tid || !this.loginInfo.f_UserId) return;
      let tableConfig = window.$getStore({ name: "tableConfig" }) || {},
        mayConfig = tableConfig[this.loginInfo.f_UserId];
      if (!mayConfig) tableConfig[this.loginInfo.f_UserId] = {};
      tableConfig[this.loginInfo.f_UserId][this.tid] = val;
      window.$setStore({ name: "tableConfig", content: tableConfig });
    },
  },
  methods: {
    async getTableConfig() {
      if (!this.tableId) return
      this.myColumns = await this.$store.dispatch('data/tableConfig/getConfig', this.tableId)
    },
    handleColumnsConfigOk(list) {
      this.myColumns = list
      this.doLayout()
      this.saveColumns()
    },
    setColumns() {
      this.$refs.columnsConfig.show({
        list: cloneDeep(this.mergedColumns)
      })
    },
    async saveColumns() {
      if (!this.tableId) return
      this.$lastOpt('saveTableConfig', async () => {
        try {
          await this.$store.dispatch('data/tableConfig/saveConfig', {
            f_UserId: this.loginInfo.f_UserId,
            f_Type: `tableConfig_${this.tableId}`,
            f_Data: JSON.stringify(this.myColumns)
          })
        } catch (error) {
          console.error('保存列配置失败:', error)
        }
      }, 500)
      
    },
    updateFooter() {
      this.$refs.learunTable.updateFooter()
    },
    loadEmptyText(){
      this.emptyText = '     '
    },
    setEmptyText(){
      this.emptyText = '暂无数据'
    },
    scroll($event){
      let event = $event
      // setTimeout(()=>{
        // 动态赋值表头偏移量
          let container = this.$refs['learunTable'].$el.querySelector('.vxe-table--header-wrapper')
          container.scrollLeft = event.scrollLeft
          container = null
      // },20)
      this.$emit('scroll',$event)
    },
    // 用于开启显示树形数据时传递行的数据，进而实现树形数据的拖拽排序
    reorder(row){
      this.$emit('reorder',row)
    },
    selectable ({row}) {
      if (!this.rowKey) return true
      let bol = this.disabeledList.indexOf(row[this.rowKey]) == -1
      return bol
    },
    getDataSource: function () {
      var e = window.tableData[this.dataId];
      if (!e) return this.dataSource;
    },
    setDataSource: function (e) {
      (this.bigDataLength = e.length), (window.tableData[this.dataId] = e);
    },
    handleSelectionChange: function (e) {
      var t = e.checked,
        n = e.row,
        r = e.rowIndex,
        i = e.$rowIndex,
        o = e.column,
        a = e.columnIndex,
        l = e.$columnIndex,
        s = e.$event;
      this.$emit("select", {
        checked: t,
        row: n,
        rowIndex: r,
        $rowIndex: i,
        column: o,
        columnIndex: a,
        $columnIndex: l,
        $event: s,
      });
    },
    handleSelectAll: function (e) {
      this.selectAll(e.records)
      // var t = e.checked,
      //   n = e.$event;
      // this.$emit("selectAll", {
      //   checked: t,
      //   $event: n,
      // });
    },
    handleCellClick: function (e) {
      var t = e.row,
        n = e.rowIndex,
        r = e.$rowIndex,
        i = e.column,
        o = e.columnIndex,
        a = e.$columnIndex,
        l = e.triggerRadio,
        s = e.triggerCheckbox,
        u = e.triggerTreeNode,
        c = e.triggerExpandNode,
        f = e.$event;
      this.$emit("rowClick", {
        row: t,
        column: i,
        $event: f,
      }),
        this.$emit("cellClick", {
          row: t,
          rowIndex: n,
          $rowIndex: r,
          column: i,
          columnIndex: o,
          $columnIndex: a,
          triggerRadio: l,
          triggerCheckbox: s,
          triggerTreeNode: u,
          triggerExpandNode: c,
          $event: f,
        });
    },
    handleCellDblclick: function (e) {
      var t = e.row,
        n = e.rowIndex,
        r = e.$rowIndex,
        i = e.column,
        o = e.columnIndex,
        a = e.$columnIndex,
        l = e.$event;
      this.$emit("rowDblclick", {
        row: t,
        column: i,
        $event: l,
      }),
        this.$emit("cellDblclick", {
          row: t,
          rowIndex: n,
          $rowIndex: r,
          column: i,
          columnIndex: o,
          $columnIndex: a,
          $event: l,
        });
    },
    handleCellMenu: function (e) {
      var t = e.row,
        n = e.column,
        r = e.$event;
      this.$emit("rowContextmenu", {
        row: t,
        column: n,
        $event: r,
      });
    },
    cellMouseEnter: function (e) {
      var t = e.row,
        n = e.rowIndex,
        r = e.$rowIndex,
        i = e.column,
        o = e.columnIndex,
        a = e.$columnIndex,
        l = e.$event;
      this.$emit("cellMouseEnter", {
        row: t,
        rowIndex: n,
        $rowIndex: r,
        column: i,
        columnIndex: o,
        $columnIndex: a,
        $event: l,
      });
    },
    cellMouseLeave: function (e) {
      var t = e.row,
        n = e.rowIndex,
        r = e.$rowIndex,
        i = e.column,
        o = e.columnIndex,
        a = e.$columnIndex,
        l = e.$event;
      this.$emit("cellMouseLeave", {
        row: t,
        rowIndex: n,
        $rowIndex: r,
        column: i,
        columnIndex: o,
        $columnIndex: a,
        $event: l,
      });
    },
    headerClick: function (e) {
      var t = e.$rowIndex,
        n = e.column,
        r = e.columnIndex,
        i = e.$columnIndex,
        o = e.triggerResizable,
        a = e.triggerSort,
        l = e.triggerFilter,
        s = e.$event;
      this.$emit("headerClick", {
        $rowIndex: t,
        column: n,
        columnIndex: r,
        $columnIndex: i,
        triggerResizable: o,
        triggerSort: a,
        triggerFilter: l,
        $event: s,
      });
    },
    headerContextmenu: function (e) {
      var t = e.type,
        n = e.column,
        r = e.columnIndex,
        i = e.$event;
      this.$emit("headerContextmenu", {
        type: t,
        column: n,
        columnIndex: r,
        $event: i,
      });
    },
    filterChange: function (e) {
      var t = e.column,
        n = e.property,
        r = e.values,
        i = e.datas,
        o = e.filterList,
        a = e.$event;
      this.$emit("filterChange", {
        column: t,
        property: n,
        values: r,
        datas: i,
        filterList: o,
        $event: a,
      });
    },
    currentChangeHandler (e) {
      let currentRow = e.newValue,
          oldCurrentRow = e.oldValue
      this.curtRowKey = currentRow[this.rowKey]
      this.$emit('update:currentRowKey', this.curtRowKey)
      this.currentChange(currentRow, oldCurrentRow)
      // var t = e.newValue,
      //   n = e.oldValue,
      //   r = e.row,
      //   i = e.rowIndex,
      //   o = e.$rowIndex,
      //   a = e.column,
      //   l = e.columnIndex,
      //   s = e.$columnIndex,
      //   u = e.$event;
      // this.$emit("currentChange", {
      //   newValue: t,
      //   oldValue: n,
      //   row: r,
      //   rowIndex: i,
      //   $rowIndex: o,
      //   column: a,
      //   columnIndex: l,
      //   $columnIndex: s,
      //   $event: u,
      // });
    },
    headerDagend: function (e) {
      var t = e.$rowIndex,
        n = e.column,
        r = e.columnIndex,
        i = e.$columnIndex,
        o = e.$event;
      if (this.tableId) {
        let columns = cloneDeep(this.mergedColumns)
        const columnIndex = this.mergedColumns.findIndex(col => col.prop === n.field)
        if (columnIndex !== -1) {
            this.$set(columns[columnIndex], 'width', e.resizeWidth)
            this.myColumns = columns
            this.saveColumns()
        }
      }
      this.$emit("headerDagend", {
        $rowIndex: t,
        column: n,
        columnIndex: r,
        $columnIndex: i,
        $event: o,
      });
    },
    expandChange: function (e) {
      var t = e.expanded,
        n = e.row,
        r = e.rowIndex,
        i = e.$rowIndex,
        o = e.column,
        a = e.columnIndex,
        l = e.$columnIndex,
        s = e.$event;
      this.$emit("expandChange", {
        expanded: t,
        row: n,
        rowIndex: r,
        $rowIndex: i,
        column: o,
        columnIndex: a,
        $columnIndex: l,
        $event: s,
      });
    },
    handleSizeChange: function (e) {
      (this.currentPageSize = e),
        this.$emit("loadPageData", {
          rows: e,
          page: this.currentPage,
          sidx: this.pageSidx,
        });
    },
    handleCurrentChange: function (e) {
      (this.currentPage = e),
        this.$emit("loadPageData", {
          rows: this.currentPageSize,
          page: e,
          sidx: this.pageSidx,
        });
    },
    sortChangeEvent: function (e) {
      var t = e.sortList;
      if (this.isPage) {
        var n = t
          .map(function (e) {
            return "".concat(e.property, " ").concat(e.order);
          })
          .join(", ");
        (this.pageSidx = n),
          this.$emit("loadPageData", {
            rows: this.currentPageSize,
            page: this.currentPage,
            sidx: n,
          });
      }
    },
    reset: function () {
      this.$emit('selectionChange', [])
      this.clearSelection();
    },
    clearSelection: function () {
      this.$refs.learunTable.clearCheckboxRow(),
        this.reserveSelection &&
          this.isMultiSelect &&
          this.$refs.learunTable.clearCheckboxReserve();
    },
    toggleRowSelection: function (e, t) {
      this.$refs.learunTable.setCheckboxRow(e, t);
    },
    getSelected: function (e) {
      var t = this.$refs.learunTable.getCheckboxRecords();
      return t;
    },
    loadData: function (e) {
      return this.setDataSource(e), this.$refs.learunTable.reloadData(e);
    },
    reLoadData: function () {
      var e = this;
      (this.isReloading = true),
        this.$nextTick(function () {
          e.isReloading = false;
        });
    },
    doLayout: function (bol, targetRow) {
      var e = this;
      (this.isShowTable = false),
        this.$nextTick(function () {
          e.isShowTable = true;
          if(bol){
            e.setSort()
          }
          if (targetRow) {
            setTimeout(() => {
                e.$refs.learunTable.scrollToRow(targetRow)
            }, 50)
          }
        });
    },
    clearCurrentColumn: function () {
      return this.$refs.learunTable.clearCurrentColumn();
    },
    indexMethod: function (e) {
      var t = e.rowIndex;
      return this.isPage
        ? (this.currentPage - 1) * this.currentPageSize + t + 1
        : t + 1;
    },
    // setSort: function () {
    //   var e = this,
    //     t = function () {
    //       var t = e.$refs.learunTable.$el.querySelectorAll(
    //         ".vxe-table--body-wrapper > table > tbody"
    //       )[0];
    //       e.dragSortable = window.Sortable.create(t, {
    //         ghostClass: "learun-table__sortable",
    //         handle: ".learun-table__drag-handler",
    //         onEnd: function (t) {
    //           var n = t.oldIndex,
    //             r = t.newIndex,
    //             i = e.getDataSource(),
    //             o = i.splice(n, 1)[0];
    //           i.splice(r, 0, o), e.$emit("sortable-change", n, r, o, i);
    //         },
    //       });
    //     };
    //   this.isSortable &&
    //     !this.isTree &&
    //     this.$nextTick(function () {
    //       t();
    //     });
    // },
    setSort() {
      const callback = () => {
        this.$nextTick(() => {
          let el = this.$refs.learunTable.$el.querySelectorAll(
          ".vxe-table--body-wrapper > table > tbody"
        )[0];
          // group: 定义拖拽组，允许或限制不同列表之间的拖拽。
          // sort: 是否允许在当前列表内排序，默认为 true。
          // delay: 拖拽延迟时间（毫秒），适用于触摸设备。
          // disabled: 禁用拖拽功能。
          // animation: 拖拽时的动画时间（毫秒）。
          // ghostClass: 拖拽元素的视觉样式类名。
          // chosenClass: 被选中元素的样式类名。
          // dragClass: 拖拽过程中元素的样式类名。
          // dataIdAttr: 用于标识元素的 HTML 属性名。
          // onStart: 拖拽开始时的回调函数。
          // onEnd: 拖拽结束时的回调函数。
          // onAdd: 元素被添加到另一个列表时的回调函数。
          // onUpdate: 列表内元素顺序更新时的回调函数。
          // onRemove: 元素从列表中移除时的回调函数。
          // onSort: 发生任何排序变化时的回调函数。
          // onMove: 元素移动时的回调函数，可以用来控制是否允许移动。
          // onClone: 克隆元素时的回调函数。
          // filter: 设置不可拖拽的元素选择器。
          // preventOnFilter: 是否阻止过滤元素上的默认事件。
          // direction: 推测拖拽方向 ('vertical', 'horizontal')。
          // forceFallback: 强制使用内置的回退机制。
          // fallbackTolerance: 触摸设备上触发回退模式的距离阈值。
          // setData: 自定义拖拽数据设置方法。
          // multiDrag: 启用多选拖拽。
          // selectedClass: 多选时选中元素的样式类名。
          // invertSwap: 反转交换逻辑。
          // invertedSwapThreshold: 交换阈值。
          // swapThreshold: 元素交换的百分比阈值。
          // emptyInsertThreshold: 在空列表中插入元素的阈值。
        this.dragSortable = window.Sortable.create(el, {
          ghostClass: "learun-table__sortable",
          handle: ".learun-table__drag-handler",
          onStart: (evt) => {
            let $el = this.$refs.learunTable.$el.querySelector('.vxe-table--body')
            let marginTop = $el.offsetTop || 0,
                startIndex = marginTop / 40
            this.startDragIndex = startIndex + evt.oldIndex;
          },
          // setData: () => {

          // },
          onEnd: (evt) => {
            let $el = this.$refs.learunTable.$el.querySelector('.vxe-table--body')
            let marginTop = $el.offsetTop || 0,
                startIndex = marginTop / 40
            const oldindex = this.startDragIndex;
            const newindex = startIndex + evt.newIndex;
            let targetRow = this.dataSource.splice(oldindex, 1)[0]
            this.dataSource.splice(newindex, 0, targetRow)
            this.$emit(
              "sortable-change",
              oldindex,
              newindex,
              targetRow,
              this.dataSource
            );
            if (this.dataSource.length < this.scrollYGt) this.doLayout(true, targetRow)
          },
        });
        el = null
        })
        
      };
      if (this.isSortable && !this.isTree) {
        this.$nextTick(() => {
          callback();
        });
      }
    },
    getSummaries: function (e) {
      function getDecimalPlaces(num) {
        const str = num.toString();
        if (str.indexOf('.') !== -1) {
          return str.split('.')[1].length;
        }
        return 0;
      }
      var t = this;
      if (this.summaryMethod) return this.summaryMethod(e);
      var n = e.columns,
        r = e.data,
        i = [];
      return (
        n.forEach(function (e, n) {
          if (0 !== n) {
            var o = t.arrayColumns.find(function (t) {
              return t.prop == e.property;
            });
            if (o && o.isSummary) {
              var a = r.map(function (t) {
                return Number(t[e.property]);
              });
              let maxFix = 0
              a.every(function (e) {
                return isNaN(e);
              })
                ? (i[n] = "")
                : (i[n] = ((a.reduce(function (e, t) {
                    var n = Number(t);
                    if (isNaN(n)) return e;
                    let fix = Math.max(getDecimalPlaces(e), getDecimalPlaces(t));
                    if (fix > 0) {
                      if (fix > maxFix) maxFix = fix;
                      e = e*10**fix, t = t*10**fix
                      return (((e + t) / (10**fix)).toFixed(maxFix))*1;
                    }
                    return e + t
                    return isNaN(n) ? e : e + t;
                  }, 0)).toFixed(maxFix))*1);
            } else i[n] = "";
          } else i[n] = t.sumText;
        }),
        [i]
      );
    },
    footerRowspanMethod: function (e) {
      var t = e._rowIndex,
        n = e._columnIndex;
      if (0 === t) {
        if (0 === n)
          return {
            rowspan: 1,
            colspan: this.footerColNum,
          };
        if (n < this.footerColNum)
          return {
            rowspan: 0,
            colspan: 0,
          };
      }
    },
    isRequired: function (e) {
      var t = this.arrayColumns.find(function (t) {
        return t.prop == e;
      });
      return !!t && t.required;
    },
    isEditable: function (e) {
      var t = this.arrayColumns.find(function (t) {
        return t.prop == e;
      });
      return !!t && t.editable;
    },
    validate: function () {
      var e = this,
        t = true,
        n = this.getDataSource();
      if (this.required && 0 == n.length)
        return (
          this.$message({
            type: "error",
            message: this.$t("请添加表格数据"),
          }),
          false
        );
      try {
        n.forEach(function (n, r) {
          e.arrayColumns.forEach(function (i) {
            if (!i.isHidden) {
              if (i.required && e.$validatenull(n[i.prop]))
                throw (
                  (e.$message({
                    type: "error",
                    message: e.$t(
                      "请输入第".concat(r + 1, "行-").concat(i.label)
                    ),
                  }),
                  (t = false),
                  new Error())
                );
              i.patterns &&
                i.patterns.length > 0 &&
                i.patterns.forEach(function (o) {
                  if (
                    o.reg &&
                    !e.$validatenull(n[i.prop]) &&
                    !new RegExp(o.reg.substring(1, o.reg.length - 1)).test(
                      n[i.prop]
                    )
                  )
                    throw (
                      (e.$message({
                        type: "error",
                        message: e.$t(
                          ""
                            .concat(o.msg, "第")
                            .concat(r + 1, "行-")
                            .concat(i.label)
                        ),
                      }),
                      (t = false),
                      new Error())
                    );
                });
            }
          });
        });
      } catch (r) {}
      return t;
    },
    handleOk: function (e, t) {
      var n = this;
      e("保存数据...");
      var r =
        window.$getStore({
          name: "table_setting_cols",
        }) || {};
      this.loginInfo
        ? ((r[this.loginInfo.f_UserId] = r[this.loginInfo.f_UserId] || {}),
          (r[this.loginInfo.f_UserId][this.lrTableName] = this.chooseItem
            .filter(function (e) {
              return e._id;
            })
            .map(function (e) {
              return e._id;
            })))
        : (r[this.lrTableName] = this.chooseItem
            .filter(function (e) {
              return e._id;
            })
            .map(function (e) {
              return e._id;
            })),
        window.$setStore({
          name: "table_setting_cols",
          content: r,
        }),
        setTimeout(function () {
          t(), (n.columnsVisible = false);
        }, 1e3);
    },
    openColumnsSetting: function () {
      this.columnsVisible = true;
    },
    columnsSettingOpened: function () {
      var e = this,
        t = this.columnsChecks || this.defaultCheckedKeys;
      (t = t.filter(function (t) {
        return (
          -1 ==
          e.arrayColumns.findIndex(function (e) {
            return e._id == t && e._hasChildren;
          })
        );
      })),
        this.$refs.columnsTree.setCheckedKeys(t);
    },
    handleColumnsCheck: function (e, t) {
      (this.columnsChecks = t.checkedKeys.concat(t.halfCheckedKeys)),
        this.doLayout();
    }
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
